import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { EvaluatorService } from "src/app/core/services/evaluator.service";
import { JwtService } from "src/app/core/services/jwt.service";
import { jwtDecode } from "jwt-decode";

@Component({
  selector: "app-evaluator-login",
  templateUrl: "./evaluator-login.component.html",
  styleUrls: ["./evaluator-login.component.scss"],
})
export class EvaluatorLoginComponent implements OnInit {
  hidePassword: boolean = true;
  loginForm: FormGroup;
  isLoading: boolean = false;

  constructor(
    private evaluatorService: EvaluatorService,
    private fb: FormBuilder,
    private jwt: JwtService,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      email: new FormControl("", [Validators.required]),
      password: new FormControl("", [Validators.required]),
    });
  }

  ngOnInit(): void {
    localStorage.clear()
  }

  onLogin() {
    const value = this.loginForm.value;
    this.isLoading = true;
    const body = {
      email: value.email,
      password: value.password,
    };
    this.evaluatorService.evaluatorLogin(body).subscribe((res) => {
      const decoded = jwtDecode(res.data.token);
      localStorage.setItem("evaluator_details", JSON.stringify({ ...res.data, role: decoded }))
      const workpass_token = res.data.token;
      this.jwt.saveToken(workpass_token);
      this.isLoading = false
      this.router.navigateByUrl("evaluator/dashboard/home")
    }, (err) => {
      this.isLoading = false
    });
  }
}
